import { Injectable, signal, effect, inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';


@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  // Inyección segura del documento HTML (mejor práctica de Angular)
  private readonly document = inject(DOCUMENT);
  
 
  private readonly _isDarkMode = signal<boolean>(false);

  
  readonly isDarkMode = this._isDarkMode.asReadonly();

  constructor() {
    this.initializeTheme();

    // El 'effect' monitorea automáticamente el signal. Si cambia, ejecuta este bloque.
    effect(() => {
      const isDark = this._isDarkMode();
      const htmlElement = this.document.documentElement;

      if (isDark) {
        htmlElement.classList.add('dark');
        localStorage.setItem('theme', 'dark');
      } else {
        htmlElement.classList.remove('dark');
        localStorage.setItem('theme', 'light');
      }
    });
  }

 
  private initializeTheme(): void {
    const savedTheme = localStorage.getItem('theme');

    const prefersDark = typeof window !== 'undefined' && 
                        window.matchMedia('(prefers-color-scheme: dark)').matches;

    if (savedTheme === 'dark' || (!savedTheme && prefersDark)) {
      this._isDarkMode.set(true);
    }
  }


  toggleTheme(): void {
    this._isDarkMode.update(current => !current);
  }
}